export function formatDistanceWithoutUnit(meters: number): string {
  return (meters / 1000).toLocaleString('cs', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}
